<script setup>
import {computed, inject, onMounted, provide, ref, watch} from "vue";
import FolderItem from "@/views/trackers/trackers/folders/FolderItem.vue";
import trackersFoldersService from "@/services/trackers-folders.service";
import {useStore} from "vue2-helpers/vuex";
import EditFolder from "@/components/trackers/EditFolder.vue";

const store = useStore();
const filterByCreator = inject('filterByCreator');

const search = inject('search');
const updateSearch = inject('updateSearch');
const status = ref('active');
const counts = ref(null);
const folders = ref([]);
const totalCounts = ref(null);
const addFolderModal = ref(null);

const hasFolders = computed(() => totalCounts.value.active > 0 || totalCounts.value.archived > 0);
const userCanAddTracker = computed(() => store.state.user.permissions.includes('tracker-create'));

watch(filterByCreator, () => {
    getList();
});

watch(updateSearch, (value) => {
    if (value) {
        getList();
    }
});

onMounted(() => {
    getTotalCounts();
});

async function getTotalCounts() {
    const {data} = await trackersFoldersService.getNumber();

    totalCounts.value = data;

    if (hasFolders.value) {
        getList();
    } else {
        folders.value = [];
        counts.value = 0;
    }

    if (status.value === 'active' && totalCounts.value.active === 0 && totalCounts.value.archived > 0) {
        status.value = 'archived';
    }

    if (status.value === 'archived' && totalCounts.value.archived === 0 && totalCounts.value.active > 0) {
        status.value = 'active';
    }
}

async function getList() {
    if (hasFolders.value && filterByCreator.value !== null) {
        const {data} = await trackersFoldersService.getIndex(filterByCreator.value, search.value);

        folders.value = data.folders;
        counts.value = data.counts;
    }
}

provide('updateData', getTotalCounts);
</script>

<template>
    <div v-if="totalCounts !== null">
        <header class="main-inner__header">
            <h3 class="heading3 mb-0 mr-auto">Trackers by Folder</h3>

            <template v-if="hasFolders">
                <template v-if="counts !== null">
                    <div v-if="status === 'active'">
                        <a v-if="counts.archived > 0" @click="status = 'archived'" class="link-archive">Show Archived</a>
                    </div>

                    <div v-if="status === 'archived'">
                        <a v-if="counts.active > 0" @click="status = 'active'" class="link-archive">Show Active</a>
                    </div>
                </template>
            </template>

            <div v-else class="no-folder">
                No Folders
            </div>

            <template v-if="userCanAddTracker">
                <b-dropdown
                    v-if="store.getters.isEnterprise"
                    class="dropdown-folder"
                    text="New Folder"
                    boundary="viewport"
                >
                    <b-dropdown-item @click="addFolderModal.open(0, 'private')">
                        Internal Folder
                    </b-dropdown-item>

                    <b-dropdown-item v-if="store.getters.isPremiumEnterprise" @click="addFolderModal.open(0, 'public')">
                        Public Collection
                    </b-dropdown-item>
                </b-dropdown>

                <div v-else class="dropdown-folder">
                    <button class="btn dropdown-toggle btn-secondary" @click="addFolderModal.open(0, 'private')">
                        New Folder
                    </button>
                </div>
            </template>
        </header>

        <b-row class="main-inner__content">
            <FolderItem
                v-for="folder in folders[status]"
                :key="folder.id"
                :folder="folder"
            />
        </b-row>

        <EditFolder
            ref="addFolderModal"
            @folderSaved="getTotalCounts"
        />
    </div>
</template>

<style scoped>

</style>
